import {Container} from './styled';

export const LoadingSpinner = () => {

    return (
      <Container />
    );

};
